const SOCIAL_EMBED_MODAL = "socialEmbedUploadModal";
const SOCIAL_EMBED_MODAL_INPUT = "socialEmbedUploadModalInput";
const SOCIAL_EMBED_MODAL_SUBMIT_BTN = "actionButtonSave";
const TOOLBAR_BUTTON_REPLACE_TO_LINK = "baseToolbarButton_replaceToLink";

export { SOCIAL_EMBED_MODAL, SOCIAL_EMBED_MODAL_INPUT, SOCIAL_EMBED_MODAL_SUBMIT_BTN, TOOLBAR_BUTTON_REPLACE_TO_LINK };
//# sourceMappingURL=dataHooks.js.map
